(function () {
    "use strict";



    Controllers.InteractiveOnboardingExplainBrandingModalController = class InteractiveOnboardingExplainBrandingModalController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            $modalInstance,
            $translate,
            CompaniesManager,
            CompanyService,
            fileData
        ) {
            super($scope, $injector);
            this.__objectType = 'InteractiveOnboardingExplainBrandingModalController';

            this.$modalInstance = $modalInstance;
            this.CompaniesManager = CompaniesManager;
            this.CompanyService = CompanyService;
            this.company = this.CompaniesManager.getCurrCompany();

            this.exampleFileType = 'invoice'
            this.exampleFileName = $translate.instant('INTERACTIVE_ONBOARDING.STEP_BRANDING.EXPLAIN_MODAL._EXAMPLE_FILE_NAME_');

            this.exampleFileBrandColor = this.company.brand_color;

            if (fileData) {
                this.exampleFileBrandColor = fileData.brandColor;
                this.exampleFileCoverImagePublicId = fileData.defaultCoverImage && fileData.defaultCoverImage.cloudinary_public_id;
                this.exampleFileLogoImagePublicId = fileData.logoImage && fileData.logoImage.cloudinary_public_id;
            }

        }

        handleClose() {
            this.$modalInstance.close();
        }


    }
}());
